import React from 'react'
import { shape, func, string, bool } from 'prop-types'
import { Button } from 'components'
/**
 * @param  {} {userActions
 * @param  {} user details from loginInfo
 * @param  {} ui ui states }
 */

const LoginThirdParty = ({ userActions: { logoutUser, authorizeUser }, ui }) => {
  const params = {
    redirect_uri: ui.redirectUri,
    client_id: ui.clientId,
    requestorigin: ui.requestOrigin,
  }
  return (
    <div className="co-third-party-login__container">
      <Button className="primary full" onClick={() => authorizeUser(params)}>
        Yes, use this account
      </Button>
      <Button className={`basic full ${ui.isCreditCardUser && 'as-link blue'}`} onClick={() => logoutUser()}>
        No, use another account
      </Button>
    </div>
  )
}

LoginThirdParty.propTypes = {
  userActions: shape({ logoutUser: func.isRequired, authorizeUser: func.isRequired }),
  ui: shape({
    redirectUri: string, clientId: string, requestOrigin: string, isCreditCardUser: bool,
  }),
}

LoginThirdParty.defaultProps = {
  userActions: {},
  ui: {},
}

export default LoginThirdParty
